module.exports = __webpack_public_path__ + "33cb6bd3598af69a5a6d38e7264f977e.svg";